import React, { FC } from "react";
import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps,
} from "@mui/material";

const CircularProgress: FC<CircularProgressProps> = (props) => (
  <MuiCircularProgress {...props} />
);

export default CircularProgress;
